module.exports = __webpack_public_path__ + "media/images/main_parkingapp-a6d3129d.jpg";